import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { voucherPageModel } from '../../model';
import { VoucherPageHeading } from '../voucher-page-heading';
import { VoucherPageTabs } from '../voucher-page-tabs';
import cls from './voucher-page.module.scss';

export const VoucherPage = () => {
	const [current, pending] = useUnit([voucherPageModel.$currentTab, voucherPageModel.$pending]);

	return (
		<AppShell.Main
			className={cls.voucherPage}
			data-tab={current}
		>
			{pending && <Loader />}
			{!pending && (
				<>
					<VoucherPageHeading />
					<VoucherPageTabs />
				</>
			)}
		</AppShell.Main>
	);
};
